export default __webpack_public_path__ + "files/f1160d089d0aed4f08d7ee9fce6ab819.png";